import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import NotificationSystem from 'react-notification-system';
import {get} from "../../server/actionsNew";
import SetupLoading from './../Misc/setupLoading/setupLoading';
import AppHeader from './../Misc/AppHeader';
import queryString from 'query-string';
import {_addNotification,_addNotificationError} from './../../server/util';
import Modal from 'react-modal';
const deleteStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
class PaymentSetup extends Component {
    constructor(props) {
        super(props);
        this.state={
            showLoading:true,
            loadingMsg:'Prcoessing...',
            url:'',
            conformModalIsOpen:false,
            errorModalIsOpen:false,
            errorMessage:''
        }
        this.completePaymentAccSetup=this.completePaymentAccSetup.bind();

    }
    componentWillMount(){
        Modal.setAppElement('body');
    }
    componentDidMount(){
        this._notificationSystem = this.refs.notificationSystem;
        let params = queryString.parse(window.location.search);
        if((params['code']===undefined?'':params['code'])!='')
            this.completePaymentAccSetup(params['code'])
            else{
                window.location.href='/paymentsetuperror';
            }
    }
    completePaymentAccSetup=(code)=>{
        let _state=this;
        
        get('/completeStripeAccSetup?authCode='+code,false).then((response) => {
            /* if (!response.ok) {
                throw Error(response.statusText);
            } */
            console.log('response', response);
            return response.json();
        }).then(data => {
            if(data.statusCode!=200){
                if(data.statusCode===417){
                    this.setState({
                        errorModalIsOpen:true,
                        errorMessage:data.statusMessage
                    })
                }
                throw Error(data.statusMessage);
            }
            console.log('Json returned from getSchoolList', data);
            _addNotification(data.statusMessage, _state);
            _state.setState({showLoading:false,conformModalIsOpen:true,url:"https://"+data.subdomain+'.mealmanage.com'});
            }).catch(
                (error) => {
                    _state.setState({showLoading:true,loadingMsg:error.message});
                    _addNotificationError(error.message,_state);
                })
    }

    render() {
        return (
            <div>
                 <NotificationSystem ref="notificationSystem"/>
                 <AppHeader/>
                 <section className="mainContent full-width clearfix">
                        <div className="container">
                        <div class="sectionTitle"><h2><span>Payment Integration In MealManage</span></h2></div>
                       {this.state.showLoading?<SetupLoading LoadingMessage={this.state.loadingMsg} />
                       :<p className="color-2 text-center">Your Payment integration successfully completed.</p>
                       
                       }
                </div>
                </section>

                <Modal
                        isOpen={this.state.conformModalIsOpen}
                        style={deleteStyles}
                        contentLabel="Publish">
                        <div className="modal-header">
                        <h3 className="panel-title color-2"><i className="fa fa-check-square-o" aria-hidden="true"></i>  Congratulations!</h3>
                                </div>
                                <div className="modal-body">
                                    <p>Your Payment integration successfully completed. Do you want to continue with school login?</p>
                                </div>
                                <div className="text-right">
                                    <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                        onClick={() => this.setState({ conformModalIsOpen: false})}><i
                                            className="glyphicon glyphicon-remove"
                                            style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                    </button>
                                    <button type="button" className="btn btn-success btn-xs"
                                        style={{ margin: '0 0 0 5px' }} onClick={()=>{
                                            
                                            this.setState({ conformModalIsOpen: false},
                                            window.location.href=this.state.url);
                                        }}
                                        id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Ok
                                    </button>
                                </div>

                        </Modal>

                        <Modal
                        isOpen={this.state.errorModalIsOpen}
                        style={deleteStyles}
                        contentLabel="Publish">
                        <div className="modal-header">
                        <h3 className="panel-title color-3"><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> Error</h3>
                                </div>
                                <div className="modal-body">
                                    <p>{this.state.errorMessage}</p>
                                </div>
                                <div className="text-right">                                    
                                    <button type="button" className="btn btn-success btn-xs"
                                        style={{ margin: '0 0 0 5px' }} onClick={()=>{
                                            
                                            this.setState({ errorModalIsOpen: false},
                                                window.location.href='/paymentsetuperror'
                                        )}}
                                        ><i className="glyphicon glyphicon-ok"></i> Ok
                                    </button>
                                </div>

                        </Modal>
            </div>

        )
    }
}
export default PaymentSetup;




// WEBPACK FOOTER //
// ./src/components/PaymentSetup/paymentSetup.jsx